import React from 'react';

const newsItems = [
  {
    id: 1,
    image: "images/resource/news-1.jpg",
   
    title: "Mercedez S class AMG Luxury Sports Coupe presented at Belgrade",
    excerpt: "It is our policy to reply to customer emails within 30 minutes of receiving them.We ensure the safety of our clients by equipping our taxis with panic buttons and GPS-linked taxis. Our fleet of vehicles ranges from mid-size to luxury vehicles. The company operates a no-refusal policy, which means that it accepts all jobs without discrimination. There are replacements available if something breaks on the trip or during the trip. Every time that a taxi or a bus is used, it is sanitized in order to provide a safe and comfortable ride. You will find our drivers to be polite, professional, and punctual. It helps us address service snags that arise from regular customer feedback.",
    link: "/",
  },
  // Add more news items here if needed
];

const NewsSection = () => {
  return (
    <section className="news-section">
      <div className="auto-container">
        <div className="content-container">
          <div className="sec-title">
            <div className="inner-title-box">
              <h2>OUR COMMITMENT TO CLIENTS</h2>
              <h4 className="rotate-title darkcolorrr">e-Travo</h4>
            </div>
          </div>

          <div className="news-list">
            {newsItems.map((item) => (
              <div className="news-block" key={item.id}>
                <div className="inner-box">
                  <div className="row clearfix">
                    {/* Image Column */}
                    <div className="image-column col-md-6 col-sm-6 col-xs-12">
                      <figure className="image">
                        <a href={item.link}>
                          <img src={item.image} alt={item.title} />
                        </a>
                      </figure>
                    </div>

                    {/* Content Column */}
                    <div className="content-column col-md-6 col-sm-6 col-xs-12">
                      <div className="inner">
                      
                        <h3><a href={item.link}>{item.title}</a></h3>
                        <div className="text">{item.excerpt}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsSection;
